import { Pressable, StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { AppBottomSheet, BottomSheetScrollView } from '@/components/atoms';

interface MeetingSummarySheetProps {
  readonly visible: boolean;
  readonly title: string;
  readonly summary: string;
  readonly onDismiss: () => void;
}

const TEXT_COLOR = '#1d1b20';

const styles = StyleSheet.create({
  header: {
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  title: {
    color: TEXT_COLOR,
    fontSize: 18,
    fontWeight: '700',
    textAlign: 'center',
  },
  divider: {
    backgroundColor: '#d5dfe6',
    height: 1,
  },
  scrollView: {
    flex: 1,
  },
  contentContainer: {
    paddingHorizontal: 16,
    paddingTop: 16,
  },
  summary: {
    color: TEXT_COLOR,
    fontSize: 16,
    letterSpacing: 0.5,
    lineHeight: 24,
  },
});

export const MeetingSummarySheet = ({
  visible,
  title,
  summary,
  onDismiss,
}: MeetingSummarySheetProps) => {
  const insets = useSafeAreaInsets();

  return (
    <AppBottomSheet visible={visible} snapPoints={['50%', '90%']} onDismiss={onDismiss}>
      <Pressable
        testID="meeting-summary-sheet-dismiss-area"
        style={styles.header}
        onPress={onDismiss}>
        <Text style={styles.title}>{title}</Text>
      </Pressable>
      <View style={styles.divider} />
      <BottomSheetScrollView
        testID="meeting-summary-sheet"
        style={styles.scrollView}
        contentContainerStyle={[styles.contentContainer, { paddingBottom: insets.bottom + 32 }]}>
        <Text style={styles.summary}>{summary}</Text>
      </BottomSheetScrollView>
    </AppBottomSheet>
  );
};
